import React, { Component } from "react";
import axios from "axios";
import {
  EditorState,
  Modifier,
  Entity,
  convertFromHTML,
  convertToRaw,
  ContentState
} from "draft-js";
import { stateFromHTML } from "draft-js-import-html";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import List from "react-virtualized/dist/commonjs/List";
import "react-virtualized/styles.css";
import emoji from "./emoji";

class AddRelatedProducts extends Component {
  state = {
    selectedProducts: [],
    showModal: false,
    shopName: null,
    divider: emoji()[0],
    storeNameSet: false
  };

  selectProduct = value => e => {
    const isSelected = e.target.checked;
    if (isSelected) {
      let p = [...this.state.selectedProducts, value];
      this.setState({ selectedProducts: p });
    } else {
      const index = this.state.selectedProducts.findIndex(
        i => i.title === value.title
      );
      let p = [...this.state.selectedProducts];
      p.splice(index, 1);
      this.setState({ selectedProducts: p });
    }
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  addToRelated = () => {
    const { divider } = this.state;
    const generateUrl = url => `https://www.teacherspayteachers.com${url}`;
    const link = (title, url) =>
      `<a href="${url}" target='_blank'>${title}</a>`;
    const words = this.state.selectedProducts.reduce(
      (p, c) => `${p} <p>${divider} ${link(c.title, generateUrl(c.url))}</p>`,
      `<p><strong>Related Products</strong></p>`
    );
    this.insertBlocksFromHtml(words);
  };

  insertBlocksFromHtml = htmlString => {
    const { editorState } = this.props;
    const blockMap = stateFromHTML(htmlString).blockMap;
    const newState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      blockMap
    );
    this.props.onChange(
      EditorState.push(editorState, newState, "insert-fragment")
    );
    this.setState({ showModal: false, selectedProducts: [] });

    return true;
  };

  rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style // Style object to be applied to row (to position it)
  }) => {
    const p = this.props.products[index];
    const checked =
      this.state.selectedProducts.findIndex(s => s.id === p.id) >= 0;
    return (
      <div key={key} style={style}>
        <label
          style={{
            width: 350,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={this.selectProduct(p)}
          />
          {p.title}
        </label>
      </div>
    );
  };

  selectDivider = divider => () => {
    this.setState({ divider });
  };

  renderModal() {
    return (
      <div className="modal-container">
        <div
          className="modal-background"
          onClick={() => this.setState({ showModal: false })}
        />
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Add Related Products</h3>
              <div
                className="close-button"
                onClick={() => this.setState({ showModal: false })}
              >
                X
              </div>
            </div>
            <div>
              <h4>Select Bullet for list:</h4>
              <div className="divider-selector">
                {emoji().map((e, index) => (
                  <div
                    key={e + index}
                    onClick={this.selectDivider(e)}
                    className={`emoji-item ${this.state.divider === e &&
                      "active"}`}
                  >
                    {e}
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h4>Select the Products</h4>
              <input
                type="text"
                onChange={this.props.onFilter}
                value={this.props.filterText}
                placeholder="Filter products ..."
              />
              <List
                {...this.state}
                width={590}
                height={300}
                rowCount={this.props.products.length}
                rowHeight={25}
                rowRenderer={this.rowRenderer}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={this.addToRelated}>
              Add Product Links
            </button>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        {this.state.showModal && this.renderModal()}
        <div className="rdw-option-wrapper" onClick={this.showModal}>
          Add related products
        </div>
      </div>
    );
  }
}

export default AddRelatedProducts;



// WEBPACK FOOTER //
// ./src/components/AddRelatedProducts.js